import { useEffect, useState } from 'react'
import { useAppDispatch } from '../../redux/hooks'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector';
import { updateExploreProfiles } from '../../redux/reducers/searchSlice'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';
import HeaderAppSettings from '../../sections/header/HeaderAppSettings';

import './style.scss';

function AppSettings() {
	const [firstSearchLoaded, setFirstSearchLoaded] = useState<boolean>(false)

	const dispatch = useAppDispatch()

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn) {
			makeInitialSearchRequest()
		} else {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		}
	}, [])

	const makeInitialSearchRequest = () => {
		instructorSearchConnector.performExploreSearchRequest().then((successRequest) => {
			setFirstSearchLoaded(true)
			dispatch(updateExploreProfiles())
			if (!successRequest) {
				console.log('WARNING - [AppExplore] - makeInitialSearchRequest() failed')
			}
		})
	}

	return (
		<>
			{firstSearchLoaded &&
				<>
					<div className='section-wrap'>
						<div className='section-content'>
							<HeaderAppSettings />
						</div>
					</div>
					<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space'>
						<div className='app-settings-list-wrap'>
							<div className='app-settings-list-item'>
								<div className='app-settings-list-title'>Referrals</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Your referral code</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Enter a referral code</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
							</div>
							<div className='app-settings-list-item'>
								<div className='app-settings-list-title'>Peyto Credit</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Your referral code</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
							</div>
							<div className='app-settings-list-item'>
								<div className='app-settings-list-title'>Notifications</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Keep up to date</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
							</div>
							<div className='app-settings-list-item'>
								<div className='app-settings-list-title'>Instructors</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Become an instructor</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Instructor dashboard</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
							</div>
							<div className='app-settings-list-item'>
								<div className='app-settings-list-title'>Stay Connected</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>FAQ's</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Contact us</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
							</div>
							<div className='app-settings-list-item'>
								<div className='app-settings-list-title'>Account</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Account privacy</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
								<div className='app-settings-list-item-row'>
									<div className='app-settings-list-item-label'>Blocked users</div>
									<img
										className='app-settings-list-item-arrow'
										src='/imgs/icons/settings/icon-settings-arrow.svg'
									/>
								</div>
							</div>
						</div>
					</div>
					<BackToTopButton />
				</>
			}
			<AppFooter activeIndex={3} />
		</>
	)
}

export default AppSettings
